import _ from 'lodash';
import moment from 'moment';
import { getLastXQuartersPeriods } from './utils';
import { PREVIOUS_PERIODS } from 'views/root/views/home/views/dashboard/GroupDashboard/GroupMetricsTable/GroupMetricsTable.consts';

export const PERIODS_LAST_X_QUARTERS = 1;

export const PERIODS_TYPES = {
  ITERATIONS: 'iterations',
  CALENDAR: 'calendar'
};

export const PERIODS = {
  ITERATIONS: {
    periodKey: 'ITERATIONS',
    menuName: 'Iterations',
    topReviewerText: 'in the current iteration',
    type: PERIODS_TYPES.ITERATIONS
  },
  PAST_7_DAYS: {
    periodKey: 'PAST_7_DAYS',
    menuName: 'Past 7 days',
    topReviewerText: 'in the past 7 days',
    after: moment().subtract(7, 'days'),
    before: moment(),
    prev_after: PREVIOUS_PERIODS.PAST_7_DAYS.after,
    prev_before: PREVIOUS_PERIODS.PAST_7_DAYS.before,
    type: PERIODS_TYPES.CALENDAR
  },
  PAST_30_DAYS: {
    periodKey: 'PAST_30_DAYS',
    menuName: 'Past 30 days',
    topReviewerText: 'in the past 30 days',
    after: moment().subtract(30, 'days'),
    before: moment(),
    prev_after: PREVIOUS_PERIODS.PAST_30_DAYS.after,
    prev_before: PREVIOUS_PERIODS.PAST_30_DAYS.before,
    type: PERIODS_TYPES.CALENDAR
  },
  PAST_90_DAYS: {
    periodKey: 'PAST_90_DAYS',
    menuName: 'Past 90 days',
    topReviewerText: 'in the past 90 days',
    after: moment().subtract(90, 'days'),
    before: moment(),
    prev_after: moment().subtract(180, 'days'),
    prev_before: moment().subtract(90, 'days'),
    type: PERIODS_TYPES.CALENDAR
  },
  MONTH_TO_DATE: {
    periodKey: 'MONTH_TO_DATE',
    menuName: 'Month to date',
    topReviewerText: 'since the beginning of this month',
    after: moment().startOf('month'),
    before: moment(),
    prev_after: PREVIOUS_PERIODS.MONTH_TO_DATE.after,
    prev_before: PREVIOUS_PERIODS.MONTH_TO_DATE.before,
    type: PERIODS_TYPES.CALENDAR
  },
  PAST_3_MONTHS: {
    periodKey: 'PAST_3_MONTHS',
    menuName: 'Past 3 months',
    topReviewerText: 'in the past 3 months',
    after: moment().subtract(3, 'months'),
    before: moment(),
    prev_after: PREVIOUS_PERIODS.PAST_3_MONTHS.after,
    prev_before: PREVIOUS_PERIODS.PAST_3_MONTHS.before,
    type: PERIODS_TYPES.CALENDAR
  },
  PAST_6_MONTHS: {
    periodKey: 'PAST_6_MONTHS',
    menuName: 'Past 6 months',
    topReviewerText: 'in the past 6 months',
    after: moment().subtract(6, 'months'),
    before: moment(),
    prev_after: moment().subtract(12, 'months'),
    prev_before: moment().subtract(6, 'months'),
    type: PERIODS_TYPES.CALENDAR
  },
  QUARTER_TO_DATE: {
    periodKey: 'QUARTER_TO_DATE',
    menuName: 'Quarter to date',
    topReviewerText: 'since the beginning of this quarter',
    after: moment().startOf('quarter'),
    before: moment(),
    prev_after: moment().subtract(1, 'quarter').startOf('quarter'),
    prev_before: moment()
      .subtract(1, 'quarter')
      .startOf('quarter')
      .add(moment().diff(moment().startOf('quarter'), 'days'), 'days'),
    type: PERIODS_TYPES.CALENDAR
  },
  ..._.keyBy(getLastXQuartersPeriods(PERIODS_LAST_X_QUARTERS), 'periodKey'),
  CUSTOM: {
    periodKey: 'CUSTOM',
    menuName: 'Custom',
    type: PERIODS_TYPES.CALENDAR,
    isReadOnlyCalendar: false
  }
};

export const DEFAULT_CALENDAR_DATES = {
  before: moment(),
  after: moment().subtract(1, 'week')
};
